import Mock from "../mock";

const database = {
  information: {
    name: '메이퀸 픽쳐스',
    aboutContent: "메이퀸 픽쳐스",
    address: '서울 성동구 성수일로 45 신한투자빌딩(메이퀸픽쳐스 빌딩) 4층',
    freelanceStatus: 'Available',
    socialLinks: {
      facebook: 'https://www.facebook.com/mqpictures',
      twitter: '',
      pinterest: '',
      behance: '',
      linkedin: '',
      dribbble: '',
      instagram: 'https://www.instagram.com/mayqueenpic/'
    },
    brandImage: '/images/brand-image.png',
    aboutImage: '/images/about-image.png',
    aboutImageLg: '/images/about-image-lg.jpg',
    cvfile: '/files/empty.pdf'
  },
  services: [
    {
      title: "대표이사",
      titleEN: "CEO",
      name: "김진천",
      icon: 'briefcase',
      details: [
        "고려대 경영학과 졸업",
        "엔터원 상무, 청암엔터테인먼트 부사장 , 마이더스필름 대표이사",
        "태왕사신기, 욕망의불꽃, 바보엄마, 메이퀸, 황금무지개, 빛나거나 미치거나, 화려한 유혹 등 제작투자, 마케팅"]
    },
    {
      title: "영화사업 본부장",
      titleEN: "Executive Director of Film Production",
      name: "하성근",
      icon: 'video',
      details: [
        "인디애나주립대 컴퓨터사이언스, 캘리포니아주립대MBA",
        "제일기획, 삼성영상사업단 한국영화팀장, KTB엔터테인먼트 이사, 한국예술종합학교 재단 사무국장", 
        "쉬리, 번지점프를하다, 태양은없다, 복수는 나의 것, 족구왕 등 한국영화 100여편 제작투자기획"]
    },
    {
      title: "전략기획 이사",
      titleEN: "CSO",
      name: "선정원",
      icon: 'rocket',
      details: [
        "일본 공학원 예술학부",
        "NHK엔터프라이즈, 영구아트무비, 일목필림, 채널제이코, 채널K",
        "카루나, 드레곤투카, 기다림 등 영화 다수, 음반 및 공연기획 다수",
        "드라마 이레자이온, 넌 어느별에서 왔니?, 스타의 연인, 에어시티, 카인과 아벨, 풀하우스 테이크2, 백년의 신부, 나의 유감스런 남자친구 등 공동제작, 투자유치, 기획개발, 해외 배급"]
    }
  ],
  reviews: [
    {
      id: 1,
      content: "Lorem quid maxime tempora.",
      author: {
        name: 'Burdette Turner',
        designation: 'Web Developer, Abc Company'
      }
    },
    {
      id: 2,
      content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam.",
      author: {
        name: 'Susan Yost',
        designation: 'Client'
      }
    }
  ],
  skills: [
    {
      title: "HTML5",
      value: 95
    },
    {
      title: "CSS3",
      value: 90
    },
    {
      title: "Javascript",
      value: 70
    },
    {
      title: "jQuery",
      value: 85
    },
    {
      title: "ReactJS",
      value: 80
    },
    {
      title: "Photoshop",
      value: 65
    }
  ],
  portfolios: [
    {
      id: 1,
      title: "T-shirt Mockup",
      subtitle: "A beautiful t-shirt mockup.",
      imageUrl: "/images/portfolio-image-1.jpg",
      largeImageUrl: ["/images/portfolio-image-1-lg.jpg"],
      url: 'https://dribbble.com'
    },
    {
      id: 2,
      title: "Coffee Mug",
      subtitle: "Awesome coffee mug design.",
      imageUrl: "/images/portfolio-image-4.jpg",
      largeImageUrl: [
        "/images/portfolio-image-4-lg.jpg",
        "/images/portfolio-image-4-lg2.jpg"
      ],
      url: 'https://facebook.com'
    },
  ],
  experience: {
    roadmap1: [
      {
        id: 1,
        year: "2006. 11",
        primary: "㈜마이더스픽쳐스 설립 (자본금 100백만원)",
      },
      {
        id: 2,
        year: "2007. 01",
        company: "인어이야기(4부작) tvN 방영",
      },
      {
        id: 3,
        year: "2007. 07",
        company: "위대한 캣츠비(24부작, tvN 창립작품) tvN 방영",
      },
      {
        id: 4,
        year: "2010. 03",
        company: "신이라 불리운 사나이(공동제작, 24부작) MBC 방영",
      },
      {
        id: 5,
        year: "2010. 11",
        company: "욕망의 불꽃(공동제작, 50부작) MBC 방영",
      },
      {
        id: 6,
        year: "2011. 11",
        primary: "㈜메이퀸픽쳐스 설립 (자본금 50백만원)",
      },
      {
        id: 7,
        year: "2012. 03",
        company: "바보엄마 (2012.03.17 ~ 2012.05.20) SBS 방영",
      },
      {
        id: 8,
        year: "2012. 08",
        company: "메이퀸 (2012.08 ~ 2012.12) MBC 방영",
      },
      {
        id: 9,
        year: "2013. 11",
        company: "황금무지개 (2013. 11 ~ 2014. 4) MBC 방영",
      },
      {
        id: 10,
        year: "2015. 01",
        company: "빛나거나 미치거나 (2015. 01 ~ 2015. 04) MBC 방영",
      },
      {
        id: 11,
        year: "2015. 06",
        details: "벤처기업 인증",
      },
      {
        id: 12,
        year: "2015. 06",
        details: "㈜마이더스픽쳐스 영업자산(기획작품, 계약 작가/원작/감독) 양수",
      },
    ],
    roadmap2: [
      {
        id: 1,
        year: "2015. 07",
        details: "유상증자 20억원 (자본금 60백만원)및 무상증자 19.4억원 (자본금 20억원)"
      },
      {
        id: 2,
        year: "2015. 10",
        secondary: "화려한 유혹(50부작) MBC 방영(2015.10~2016.03)",
      },
      {
        id: 3,
        year: "2016. 05",
        details: "외부감사의견 “적정“ 평가(삼정KPMG, K-IFRS 기준, 2015회계년도)"
      },
      {
        id: 4,
        year: "2016. 12",
        details: "교양/다큐/예능 전문외주제작사 ㈜앤미디어 인수협약 체결"
      },
      {
        id: 5,
        year: "2017. 05",
        secondary: "도둑놈 도둑님(50부작) MBC 방영(2017.05 ~ 2017.11)",
      },
      {
        id: 6,
        year: "2017. 12",
        secondary: "로봇이 아니야(35분 32부작) MBC 방영(2017.12 ~2018.01)",
      },
      {
        id: 7,
        year: "2019. 01",
        secondary: "최고의 치킨(60분 12부작) MBN,드라맥스 방영(2019.01. ~ 2019.02)",
      },
      {
        id: 8,
        year: "2020. 08",
        secondary: "내가 가장 예뻤을 때 (16부작) MBC방영(2020.08. ~ 2020.10)",
      },
      {
        id: 9,
        year: "2021. 02",
        secondary: "KBS2 저녘 일일드라마 “미스 몬테크리스토“ (40분 100부작) 방영",
      },
      {
        id: 10,
        year: "2021. 04",
        secondary: "KBS2 수목드라마 “대박부동산“ (35분 32부작) 방영",
      },
      {
        id: 11,
        year: "2022. 03",
        secondary: "tvN 수목드라마 “킬힐“ (75분 14부작) 방영",
      },
      {
        id: 12,
        year: "2023. 08",
        recent: "KBS2 일일드라마 “우아한 제국“ (40분 100부작) 방영",
      }
    ]
  },
  works: [
    {
      id: 1,
      title: '인어이야기',
      featuredImage: '/images/works/mermaid-story.jpg',
      filesource: '../../works/mermaid-story.md',
      createDate: '17',
      createMonth: 'January',
      createYear: "2007"
    },
    {
      id: 2,
      title: '위대한  캣츠비',
      featuredImage: '/images/works/great-catsby.jpg',
      filesource: '../../works/great-catsby.md',
      createDate: '4',
      createMonth: 'July',
      createYear: "2007"
    },
    {
      id: 3,
      title: '신이라 불리운 사나이',
      featuredImage: '/images/works/the-man-called-GOD.jpg',
      filesource: '../../works/the-man-called-GOD.md',
      createDate: '6',
      createMonth: 'March',
      createYear: "2010"
    },
    {
      id: 4,
      title: '욕망의 불꽃',
      featuredImage: '/images/works/flames-of-desire.jpg',
      filesource: '../../works/flames-of-desire.md',
      createDate: '2',
      createMonth: 'October',
      createYear: "2010"
    },
    {
      id: 5,
      title: '바보엄마',
      featuredImage: '/images/works/dummy-mommy.jpg',
      filesource: '../../works/dummy-mommy.md',
      createDate: '17',
      createMonth: 'March',
      createYear: "2012"
    },
    {
      id: 6,
      title: '메이퀸',
      featuredImage: '/images/works/may-queen.jpg',
      filesource: '../../works/may-queen.md',
      createDate: '18',
      createMonth: 'August',
      createYear: "2012"
    },
    {
      id: 7,
      title: '황금무지개',
      featuredImage: '/images/works/golden-rainbow.jpg',
      filesource: '../../works/golden-rainbow.md',
      createDate: '2',
      createMonth: 'November',
      createYear: "2013"
    },
    {
      id: 8,
      title: '빛나거나 미치거나',
      featuredImage: '/images/works/shine-or-go-crazy.jpg',
      filesource: '../../worksshine-or-go-crazy.md',
      createDate: '19',
      createMonth: 'Jan',
      createYear: "2015"
    },
    {
      id: 9,
      title: '화려한 유혹',
      featuredImage: '/images/works/glamorous-temptation.jpg',
      filesource: '../../works/glamorous-temptation.md',
      createDate: '5',
      createMonth: 'September',
      createYear: "2015"
    },
    {
      id: 10,
      title: '도둑놈 도둑님',
      featuredImage: '/images/works/good-thieves.jpg',
      filesource: '../../works/good-thieves.md',
      createDate: '13',
      createMonth: 'May',
      createYear: "2017"
    },
    {
      id: 11,
      title: '로봇이 아니야',
      featuredImage: '/images/works/im-not-a-robot.jpg',
      filesource: '../../works/im-not-a-robot.md',
      createDate: '6',
      createMonth: 'December',
      createYear: "2017"
    },
    {
      id: 12,
      title: '최고의 치킨',
      featuredImage: '/images/works/the-chegos-chicken.jpg',
      filesource: '../../works/the-chegos-chicken.md',
      createDate: '2',
      createMonth: 'January',
      createYear: "2019"
    },
    {
      id: 13,
      title: '내가 가장 예뻤을 때',
      featuredImage: '/images/works/when-i-was-the-prettiest.jpg',
      filesource: '../../works/when-i-was-the-prettiest.md',
      createDate: '19',
      createMonth: 'August',
      createYear: "2020"
    },
    {
      id: 14,
      title: '미스 몬테크리스토',
      featuredImage: '/images/works/miss-montecristo.jpg',
      filesource: '../../works/miss-montecristo.md',
      createDate: '15',
      createMonth: 'February',
      createYear: "2021"
    },
    {
      id: 15,
      title: '대박부동산',
      featuredImage: '/images/works/daebak-realestate.jpg',
      filesource: '../../works/daebak-realestate.md',
      createDate: '14',
      createMonth: 'April',
      createYear: "2021"
    },
    {
      id: 16,
      title: '킬힐',
      featuredImage: '/images/works/kill-heel.jpg',
      filesource: '../../works/kill-heel.md',
      createDate: '9',
      createMonth: 'March',
      createYear: "2022"
    },
    {
      id: 17,
      title: '우아한 제국',
      featuredImage: '/images/works/elegant-empire.jpg',
      filesource: '../../works/elegant-empire.md',
      createDate: '7',
      createMonth: 'August',
      createYear: "2023"
    }
  ],
  contactInfo: {
    phoneNumbers: ['+82 0504-338-6938'],
    address: ["서울특별시 성동구 뚝섬로1길 25 (성수동1가, 서울숲 한라에코밸리) 602호 (04778)", "#602,	25, Ttukseom-ro 1-gil, Seongdong-gu, Seoul, Korea (04778)"]
  }
}


Mock.onGet("/api/information").reply(config => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply(config => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply(config => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply(config => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply(config => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/experience").reply(config => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply(config => {
  const response = database.blogs;
  return [200, response];
});

Mock.onGet("/api/contactinfo").reply(config => {
  const response = database.contactInfo;
  return [200, response];
});

Mock.onGet("/api/works").reply(config => {
  const response = database.works;
  return [200, response];
});